import * as Yup from 'yup';
import { TicketStatus } from 'src/models/TicketModel';
import { t } from 'src/lib/language';

const toOptionalNumber = (value: any, originalValue: any) => (
  originalValue === '' || originalValue === null ? undefined : value
);

// `isIdentifierRequired` comes from the selected product's `identifier_required` flag, which is not
// a field on the ticket itself, so it cannot be resolved with a Yup `when()` on a sibling key.
const TicketValidator = (lang: string, isIdentifierRequired = false) => Yup.object().shape({
  event_id: Yup.number()
    .min(1, t(lang, 'validations.ticket.event_required'))
    .required(t(lang, 'validations.ticket.event_required')),
  product_id: Yup.number()
    .min(1, t(lang, 'validations.ticket.product_required'))
    .required(t(lang, 'validations.ticket.product_required')),
  contact_id: Yup.number()
    .min(1, t(lang, 'validations.ticket.contact_required'))
    .required(t(lang, 'validations.ticket.contact_required')),
  status: Yup.string()
    .oneOf(Object.values(TicketStatus), t(lang, 'validations.ticket.status_invalid'))
    .required(t(lang, 'validations.ticket.status_required')),
  ticket_identifier: isIdentifierRequired
    ? Yup.string().required(t(lang, 'validations.ticket.identifier_required'))
    : Yup.string().nullable().notRequired(),
  seller_id: Yup.number()
    .transform(toOptionalNumber)
    .nullable()
    .notRequired(),
  invoice_id: Yup.number()
    .transform(toOptionalNumber)
    .nullable()
    .notRequired(),
  sold_price: Yup.number()
    .transform(toOptionalNumber)
    .min(0, t(lang, 'validations.ticket.sold_price_negative'))
    .nullable()
    .notRequired(),
  first_name: Yup.string().nullable().notRequired(),
  last_name: Yup.string().nullable().notRequired(),
  email: Yup.string()
    .email(t(lang, 'validations.ticket.email_invalid'))
    .nullable()
    .notRequired(),
  phone: Yup.string().nullable().notRequired(),
});

export default TicketValidator;
